import React from 'react';
import Chart from 'react-apexcharts';
import { Category } from '../../types/Lessons';

const RadarChart = (props: { categories: Category[]}) => {

  const series = [{
    name: 'Causes',
    data: props.categories.map(category => category.causes)
  }];

  const options = {
    chart: {
      type: 'radar',
      toolbar: { show: false },
      offsetX: 0,
      offsetY: -20,
      parentHeightOffset: 0
    },
    plotOptions: {
      radar: {
        size: 120,
        polygons: {
          strokeColors: 'var(--color-greyDark)',
          connectorColors: 'var(--color-greyDark)',
        }
      },
    },
    xaxis: {
      categories: props.categories.map(category => category.name),
      labels: {
        show: true,
        style: {
          colors: props.categories.map(() => 'var(--text-primary)'),
          fontSize: 10,
          fontFamily: 'var(--header-font)'
        }
      },
      axisTicks: { show: false },
      axisBorder: { show: false }
    },
    yaxis: {
      show: false
    },
    grid: {
      show: false
    },
    stroke: {
      width: 2.5,
      colors: ['var(--color-purple)']
    },
    colors: ['var(--color-purple)'],
    fill: {
      type: 'gradient',
      gradient: {
        type: 'vertical',
        gradientToColors: ['var(--color-purpleLight'],
        inverseColors: false,
        opacityFrom: 0.6,
        opacityTo: 0,
        stops: [0, 100]
      }
    },
    markers: {
      size: 5,
      colors: ['var(--color-purple)'],
      strokeColors: 'white',
      strokeWidth: 1.5
    },
    legend: {
      show: false
    },
  };

  return <Chart options={options} series={series} type="radar" height={350} />
};

export default RadarChart;